import { Tag } from 'antd';
import { formatCurrency } from '../../utils';

const BalanceTag = ({ balance }) => {
    const getBalanceColor = () => {
        const credit = balance?.creditLimit ?? 0;
        const bal = balance?.balance ?? 0;

        if (bal < 0) {
            return { color: 'green-inverse', class: 'green' };
        }

        if (bal > credit) {
            return { color: 'red-inverse', class: 'red' };
        }

        const percentage = (bal / credit) * 100;

        if (percentage >= 80) {
            return { color: 'orange-inverse', class: 'orange' };
        }

        return { color: 'gray', class: 'gray' };
    };

    return (
        <Tag
            color={getBalanceColor()?.color}
            className='py-2 border-round-lg page-title'
        >
            Balance: {formatCurrency(balance?.balance || 0)}
        </Tag >
    );
};

export default BalanceTag;